import BigNumber from 'bignumber.js';
import { addMilliseconds, differenceInSeconds } from 'date-fns';

import { SECONDS_IN_DAY } from 'modules/api/const';

export function getClaimTimeLeft(
  executedAt: Date,
  unstakePeriodDays: BigNumber,
): Date | null {
  const unstakePeriodMs = unstakePeriodDays
    .multipliedBy(SECONDS_IN_DAY * 1000)
    .toNumber();
  const unlockTime = addMilliseconds(executedAt, unstakePeriodMs);

  const now = new Date();

  const secondsLeft = differenceInSeconds(unlockTime, now);

  return secondsLeft > 0 ? unlockTime : null;
}
